import React, { Component } from "react";
import DataContainer from "components/utility/data-container/DataContainer";
import HeaderContent from "./HeaderContent";

class Header extends Component {
	render() {
		return (
			<DataContainer data="publicGlobalNav">
				<HeaderContent />
			</DataContainer>
		);
	}
}

export default Header;
